import { render, staticRenderFns } from "./DriverPoint.vue?vue&type=template&id=4a4f228a&scoped=true&"
import script from "./DriverPoint.vue?vue&type=script&lang=ts&"
export * from "./DriverPoint.vue?vue&type=script&lang=ts&"
import style0 from "./DriverPoint.vue?vue&type=style&index=0&id=4a4f228a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4f228a",
  null
  
)

export default component.exports